// The Heartbeat recommended shelf, as one shared query definition.
//
// Three surfaces read this shelf: Explore renders all four picks, Today offers
// the first as its quiet suggestion, and the app shell warms it on load. They
// must agree on the key, the fetcher, and the freshness window, or the shelf
// refetches on every navigation and the member watches it flash in again.
import { queryOptions } from "@tanstack/react-query";
import { getLibraryRecommendations } from "./api.js";
import { queryKeys } from "./query-keys.js";
/*
 * The shelf is a slow read (context build, one vector search per content type,
 * an LLM call for the "why") and a stable answer: it is picked from a trend
 * that moves over days, not minutes. core-api caches it per member for 30
 * minutes, so matching that here means a member moving between Today and
 * Explore inside a session never waits on it twice.
 */
export const LIBRARY_RECOMMENDATIONS_STALE_MS = 30 * 60_000;
/*
 * Kept far past the stale window so a member who wanders off to Settings and
 * comes back still paints instantly from cache while the refetch runs behind
 * the already-rendered shelf.
 */
export const LIBRARY_RECOMMENDATIONS_GC_MS = 6 * 60 * 60_000;
export function libraryRecommendationsQuery(client) {
    return queryOptions({
        queryKey: queryKeys.libraryRecommendations,
        queryFn: () => getLibraryRecommendations(client),
        staleTime: LIBRARY_RECOMMENDATIONS_STALE_MS,
        gcTime: LIBRARY_RECOMMENDATIONS_GC_MS,
    });
}
//# sourceMappingURL=library-recommendations-query.js.map